export default __webpack_public_path__ + "static/media/avatar_129.8cb1c4ef.png";